import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material'
import {
  formatMinutesToSeconds,
  formatSecondsToMinutes
} from '../../utils/time'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import css from './ModalEditarVideo.module.css'

const ModalEditarVideo = ({ open, video, onClose, onSubmit }) => {
  const [datos, setDatos] = useState({
    nombre: '',
    url: '',
    duracion: '',
    asignaturas: []
  })

  useEffect(() => {
    setDatos({
      nombre: video?.nombre || '',
      url: video?.url || '',
      duracion: formatSecondsToMinutes(video?.duracion) || '',
      asignaturas: video?.asignaturas?.map(asig => asig.id) || []
    })
  }, [open, video])

  const handleSubmit = () => {
    onSubmit({
      video: video.id,
      nombre: datos.nombre,
      url: datos.url,
      duracion: formatMinutesToSeconds(datos.duracion),
      asignaturas: datos.asignaturas
    })
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='sm'>
      <DialogTitle>Editar video</DialogTitle>
      <DialogContent className={css.main}>
        <div className={css.intro}>
          <TextField
            label='Nombre'
            value={datos.nombre}
            className={css.input}
            variant='standard'
            onChange={e => setDatos({ ...datos, nombre: e.target.value })}
          />
          <TextField
            label='URL'
            value={datos.url}
            className={css.input}
            variant='standard'
            onChange={e => setDatos({ ...datos, url: e.target.value })}
          />
          <TextField
            className={css.input}
            label='Duración'
            value={datos.duracion}
            onChange={e => setDatos({ ...datos, duracion: e.target.value })}
            variant='standard'
          />
          <AsignaturaSelector
            className={css.input}
            label='Asignaturas'
            multiple={true}
            value={datos.asignaturas}
            onChange={(event, newValue) =>
              setDatos({
                ...datos,
                asignaturas: newValue?.map(asig => asig.id) || []
              })
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button color='primary' onClick={handleSubmit}>
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarVideo
